import VoterAxiosInstance from './VoterAxiosInstance'

export const MyCandidateService = {
  updateDefaultCandidacy: async (data) => {
    try {
      await VoterAxiosInstance.put(`/nominations/mycandidacy`, data)
      return { success: true }
    } catch (error) {
      /* empty */
    }
  },
  getMyDefaultCandidacy: async () => {
    try {
      const myCandidacy = await VoterAxiosInstance.get(`/nominations/mycandidacy`)
      return { myCandidacy }
    } catch (error) {
      /* empty */
    }
  },
  getMyCandidacyPositions: async () => {
    try {
      const myCandidacyPositions = await VoterAxiosInstance.get(`/nominations/mycandidacy/positions`)
      return myCandidacyPositions
    } catch (error) {
      /* empty */
    }
  },
  getMyCandidacyDetailsPosition: async (eventId, qid) => {
    try {
      const myCandidacy = await VoterAxiosInstance.get(`/nominations/events/${eventId}/questions/${qid}/nominees/self`)
      return { myCandidacy }
    } catch (error) {
      /* empty */
    }
  },
  getMyCandidacyDetails: async (candidacyId) => {
    try {
      const myCandidacy = await VoterAxiosInstance.get(`/nominations/mycandidacy/${candidacyId}`)
      return { myCandidacy }
    } catch (error) {
      /* empty */
    }
  },
  acceptNomination: async (nominationId, data) => {
    try {
      // data includes "bio": string and "acceptTerms":boolean must be true
      await VoterAxiosInstance.put(`/nominations/${nominationId}/accept`, data)
    } catch (error) {
      /* empty */
    }
  },
  rejectNomination: async (nominationId) => {
    try {
      await VoterAxiosInstance.put(`/nominations/${nominationId}/reject`)
    } catch (error) {
      /* empty */
    }
  },
  withdrawNomination: async (nominationId, reason) => {
    try {
      await VoterAxiosInstance.put(`/nominations/${nominationId}/withdraw`, { reason })
    } catch (error) {
      /* empty */
    }
  },
  updateBioNomination: async (nominationId, data) => {
    try {
      // data includes "bio": string
      await VoterAxiosInstance.put(`/nominations/${nominationId}/bio`, data)
    } catch (error) {
      /* empty */
    }
  },
  downloadEndorsementList: async (candidacyId, locale = 'en') => {
    try {
      const resp = await VoterAxiosInstance.get(`/nominations/mycandidacy/${candidacyId}/endorsements/csv?locale=${locale}`, {
        responseType: 'blob',
      })
      return { success: true, data: resp }
    } catch (error) {
      return { error }
    }
  },
}
export default MyCandidateService
